<template>
  <div class="header" v-loading="loading" element-loading-background="rgba(122, 122, 122, 0.8)">
    <header class="gl-header">
      <div class="header-wrap">
        <div class="content-wrap">
          <el-row type="flex" justify="space-between" class="header-nav">
            <el-col :span="10">
              <div class="icon" style="width: 33.5625rem; height: 3.3125rem; display: flex">
                <a v-if="redirectSmartedu" href="https://smartedu.cn" target="_blank">
                  <img src="@/assets/global/header3.6b7595a.png" alt="" style="width: 5.125rem; height: 3.3125rem" />
                </a>
                <img v-else src="@/assets/global/header3.6b7595a.png" alt="" style="width: 5.125rem; height: 3.3125rem" />
                <div class="xian" data-v-28fe217c=""></div>
                <a v-if="redirectSmartedu" :href="smartEduUrl" target="_blank">
                  <img src="@/assets/default/header2.f67cc05.png" alt="" style="
                      width: 15.1875rem;
                      height: 3.125rem;
                      margin-top: 0.3125rem;
                    " />
                </a>
                  <img v-else src="@/assets/default/header2.f67cc05.png" alt="" style="
                      width: 15.1875rem;
                      height: 3.125rem;
                      margin-top: 0.3125rem;
                    " />
              </div>
            </el-col>
            <el-col :span="10">
              <div class="text-wrap">
                <i class="iconfont">
                  <img src="imgs/icon/student.svg" alt="" />
                </i>
                <span><a :href="studentUrl" target="_blank" style="color:#fff">学生登录</a></span>
                <i class="iconfont">
                  <img src="imgs/icon/company.svg" alt="" />
                </i>
                <span><a :href="companyUrl" target="_blank" style="color:#fff">单位登录</a></span>
                <i class="iconfont">
                  <img src="imgs/icon/school.svg" alt="" />
                </i>
                <span><a :href="teacherUrl" target="_blank" style="color:#fff">学校登录</a></span>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
      <div class="header-menu">
        <div class="content-wrap">
          <el-menu :default-active="menuIndex" class="el-menu-wrap" mode="horizontal">
            <template v-for="item in menuList">
              <!-- 有子菜单：使用 el-submenu，鼠标悬浮展开 -->
              <el-submenu v-if="item.children && item.children.length > 0" :index="item.index" :key="'sub-' + item.index">
                <template slot="title">{{ item.title }}</template>
                <el-menu-item v-for="child in item.children" :index="child.index" :key="child.index" @click="goto(child)">
                  {{ child.title }}
                </el-menu-item>
              </el-submenu>
              <!-- 无子菜单：普通菜单项 -->
              <el-menu-item v-else :index="item.index" :key="'item-' + item.index" @click="goto(item)">
                {{ item.title }}
              </el-menu-item>
            </template>
          </el-menu>

          <div class="search-input-wrap">
            <input type="text" v-model="keyword" placeholder="请输入搜索关键字" class="search-input" @chnage="goSearch" />
            <img src="imgs/search-btn.png" class="search-btn" />
          </div>
        </div>
      </div>
    </header>
    <!--轮播图-->

    <section class="swipe-wrap">
      <el-carousel :height="swipeHeight" :arrow="option.arrow" :indicator-position="option.indicatorPosition">
        <el-carousel-item v-for="item in swipeList" :key="item.id">
          <a v-if="item.isExternal" :href="item.url" target="_blank">
            <img :src="item.coverImgUrl" :alt="item.title" class="block-img" />
          </a>
          <a v-else :href="`/notice-detail.html?id=` + item.id + `&key=` + item.navId">
            <img :src="item.coverImgUrl" :alt="item.title" class="block-img" />
          </a>
        </el-carousel-item>
      </el-carousel>
    </section>
  </div>
</template>

<script>
import tool from '@/utils/tool'
export default {
  name: "mHeader",
  data() {
    return {
      keyword: "",
      loading: false,
      menuIndex: "/",
      menuList: [
        { title: "首页", link: "./", index: "1" },
        // { title: "招聘会", link: "/jobfair.html", index: "2" },
        // { title: "通知公告", link: "/notice.html", index: "3" },
        // { title: "就业动态", link: "/notice.html?key=2", index: "4" },
        // { title: "就业报告", link: "/report.html", index: "5" },
        // { title: "省内高校", link: "/school.html", index: "6" },
      ],
      swipeList: [
        // {
        //   id: 0,
        //   coverImgUrl: "imgs/banner/banner03.png",
        //   title: "",
        //   url: "https://www.smartedu.cn/special/cpc20/",
        //   isExternal: true
        // },
        // {
        //   id: 2,
        //   coverImgUrl: "imgs/banner/banner01.jpg",
        //   title: "",
        //   url: "https://hunbys.ncss.cn/student/jobfair/fairdetails.html?fairId=Y1s5NT6ZWo2kndMEhVthA7",
        //   isExternal: true
        // },
      ],
      swipeHeight: "500px",
      option: {
        arrow: "never",
        indicatorPosition: "none",
      },
      studentUrl: process.env.VUE_APP_STUDENT_URL,
      companyUrl: process.env.VUE_APP_COMPANY_URL,
      teacherUrl: process.env.VUE_APP_TEACHER_URL,
      redirectSmartedu:process.env.VUE_APP_REDIRECT_SMART_EDU==`true`?true:false,
      smartEduUrl:process.env.VUE_APP_SMART_EDU_URL,
    };
  },
  props: {
    params: {
      type: Object,
      default() {
        return {
          menuIndex: "1",
          swipeHeight: "500px",
        };
      },
    },
  },
  watch: {
    params: {
      handler(nVal) {
        if (nVal && nVal.menuIndex !== this.menuIndex) {
          this.init();
        }
      },
      deep: true,
    },
  },
  async created() {
    this.init();
  },
  async mounted() {
    // this.loading = true;
    var key = 'menus';
    var tmpMenus = tool.data.get(key);
    console.log('tmpMenus', tmpMenus);
    if (!tmpMenus) {
      var res = await this.$api.getNavList({});
      tmpMenus = res ?? [];
      tool.data.set(key, tmpMenus, 10 * 60)
    }
    // 构建树形菜单数据，支持父子级菜单
    const menuTree = this.buildMenuTree(tmpMenus);
    menuTree.forEach(item => {
      this.menuList.push(item);
    });
    var res1 = await this.$api.getNoticeList({ page: 1, pageSize: 5, category: process.env.VUE_APP_BANNER_ID });
    this.swipeList = res1.items;
  },
  methods: {
    /**
     * 将扁平的菜单数据构建为树形结构
     * @param {Array} list - 扁平菜单数据，包含 id、pid、name、url 等字段
     * @returns {Array} 树形菜单数据，顶级菜单包含 children 子菜单数组
     */
    buildMenuTree(list) {
      if (!Array.isArray(list)) return []
      // 筛选顶级菜单（pid为0），按 sort 字段升序排序
      const topMenus = list.filter(item => item.pid === 0).sort((a, b) => a.sort - b.sort)
      return topMenus.map(parent => {
        // 查找当前顶级菜单的子菜单，按 sort 字段升序排序
        const children = list
          .filter(item => item.pid === parent.id)
          .sort((a, b) => a.sort - b.sort)
          .map(child => ({
            title: child.name,
            link: child.url,
            index: String(child.id),
            isExternal: child.isExternal
          }))
        return {
          title: parent.name,
          link: parent.url,
          index: String(parent.id),
          isExternal: parent.isExternal,
          children: children
        }
      })
    },
    goSearch() {
      this.$emit("search", this.keyword);
    },
    goto(item) {
      // 外部链接在新标签页打开，内部链接在当前页跳转
      if (item.isExternal) {
        window.open(item.link, '_blank')
      } else {
        window.location.href = item.link
      }
      aplus_queue.push({
        'action': 'aplus.record',
        'arguments': ['category_click', 'CLK', {
          //以下为事件属性
          category_name: item.title, category_id: item.link
        }]
      });
    },
    init() {
      this.menuIndex = this.params.menuIndex;
      // this.swipeHeight = this.params.swipeHeight;
      this.swipeList = this.params.swipeList
        ? this.params.swipeList
        : this.swipeList;
      this.option = Object.assign({}, this.option, this.params.option || {});
    },

  },
};
</script>

<style scoped lang="scss">
// 轮播图宽度修改
// .banner{
//     min-height: 100%;
//     background-color: aqua;
// }
.swipe-wrap {
  //padding-left:230px;
}

.xian {
  width: 0.0625rem;
  height: 2.8125rem;
  background: #fff;
  margin: 0 1.5625rem;
  margin-top: 0.5rem;
}
</style>